export default __webpack_public_path__ + "static/media/amex.0be38540.svg";